<div class="sidenav" [class.sidenav-collapsed]="collapsed">
  <div class="scrollwrap scrollwrap_delayed" style="width: 100%">
    <ul class="sidenav-nav">
      <ng-container *ngFor="let data of navData">
        <li class="sidenav-nav-item" *ngIf="data.visible !== false">
          <a
            class="sidenav-nav-link"
            [ngClass]="{ active: isMenuParentActive(data) }"
            [title]="data.label"
            (click)="handleClick(data)"
            *ngIf="data.items && data.items.length > 0"
          >
            <lucide-icon class="sidenav-link-icon" [name]="data.icon"></lucide-icon>
            <span class="sidenav-link-text" @fadeInOut *ngIf="showDescriptions">
              {{ data.label }}
            </span>
            <lucide-icon
              *ngIf="data.items && showDescriptions"
              class="menu-collapse-icon ml-auto"
              [name]="!data.expanded ? 'chevron-down' : 'chevron-up'"
            >
            </lucide-icon>
          </a>

          <a
            class="sidenav-nav-link"
            [ngClass]="getActiveClass(data)"
            [title]="data.label"
            *ngIf="!data.items || data.items.length === 0"
            [routerLink]="[data.routeLink]"
            (click)="shrinkItems(data)"
          >
            <lucide-icon class="sidenav-link-icon" [name]="data.icon"></lucide-icon>
            <span class="sidenav-link-text" @fadeInOut *ngIf="showDescriptions">
              {{ data.label }}
            </span>
          </a>

          <div *ngIf="showDescriptions && data.items && data.items.length > 0">
            <app-sublevel-menu
              [data]="data"
              [collapsed]="collapsed"
              [multiple]="multiple"
              [expanded]="data.expanded"
            >
            </app-sublevel-menu>
          </div>
        </li>
      </ng-container>
    </ul>
  </div>
</div>
